var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "component/btn/secondary/icon@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2758837,4 C9.53362377,4 8.78120174,4.12911647 8.02073469,4.38057609 C6.29507573,4.95080521 5.12113646,6.09528513 4.51627722,7.80660752 C3.94783233,9.41527173 3.86166583,11.0605542 4.19447602,12.7318717 C4.49214213,14.2258127 5.0582582,15.6173073 5.79120279,16.9453019 C6.78561085,18.7463708 8.03153196,20.365195 9.40257446,21.891521 C11.0623912,23.7393682 12.8831085,25.4183056 14.788087,27.0087665 C15.1861043,27.3410827 15.5892026,27.6672605 15.9944181,28 C16.0253279,27.977775 16.039936,27.96825 16.0534855,27.9574551 C18.1650942,26.2615843 20.1922301,24.4727921 22.0453393,22.4935001 C23.4591475,20.9834724 24.7582081,19.3839098 25.8271386,17.6071825 C26.7550693,16.0647699 27.4753112,14.4387491 27.8195538,12.6603284 C28.1328866,11.0410809 28.0426975,9.44702168 27.5134192,7.8853474 C27.0906317,6.6382093 26.3557817,5.61776586 25.2051307,4.94403189 C24.1433985,4.32257951 23.0054501,4.00592666 21.8010244,4.00592666 C21.5819032,4.00592666 21.3606649,4.01629831 21.1373094,4.03746494 C20.1970995,4.12594147 19.3081236,4.39158274 18.490918,4.87587533 C17.4691991,5.48145274 16.7142366,6.34081809 16.1282196,7.36062653 C16.0882062,7.43026476 16.0488279,7.50011465 16.0005577,7.58499286 C15.9385263,7.47725469 15.8877156,7.38687316 15.8354229,7.2973383 C15.2223069,6.2495899 14.4355876,5.36672958 13.3533194,4.79078546 C12.3506546,4.25696294 11.3234313,4 10.2758837,4 M10.2758837,5.79916392 C11.0448192,5.79916392 11.7747998,5.98881696 12.5077444,6.37891803 C13.1968647,6.74573581 13.7773772,7.34326989 14.2820969,8.20602191 C14.3142771,8.26084349 14.3456103,8.31608841 14.3801193,8.37620165 L14.4393984,8.48012982 L16.0071208,11.2133773 L17.5648926,8.47420316 L17.609352,8.39588662 L17.6885321,8.25682183 C18.1657294,7.42645477 18.7282463,6.82680401 19.4086865,6.42336796 C19.9703567,6.09041681 20.5910942,5.89589544 21.3060434,5.82858554 C21.4722367,5.81292223 21.6388536,5.80509058 21.8010244,5.80509058 C22.6847075,5.80509058 23.5006429,6.0313619 24.2958306,6.49681619 C25.0067572,6.91274055 25.5015266,7.55599457 25.8091431,8.46277318 C26.2329892,9.7135096 26.3128043,10.9748293 26.0528228,12.318699 C25.7797152,13.7300901 25.2013199,15.1565096 24.2850333,16.6798723 C23.3916116,18.1649234 22.2291047,19.6643677 20.7316706,21.2639303 C19.3688848,22.7193481 17.8460453,24.1411109 16.0005577,25.6769619 C15.9808686,25.6606636 15.9611794,25.6441536 15.9414903,25.6276436 C13.8851382,23.9110296 12.1842495,22.295592 10.7414368,20.6892562 C9.29608367,19.0801686 8.19222085,17.5711993 7.36675842,16.0757766 C6.66027775,14.7960418 6.20001734,13.587427 5.95951328,12.3805055 C5.68026606,10.9790627 5.76325689,9.67900799 6.21314344,8.40583494 C6.63148501,7.22156174 7.38538902,6.4853862 8.58536877,6.08872348 C9.16693977,5.89653044 9.73559637,5.79916392 10.2758837,5.79916392",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "component/btn/secondary/icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#47D5CD",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)",
    id: "icons/fav/wired"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-4)",
    fill: "#47D5CD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/ambient/sophia"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1X);
export default __webpack_public_path__ + "static/media/icon@1x.63343d4ac3ba6f78778bcd4da640ffa3.svg";
export { ForwardRef as ReactComponent };